import React from 'react';
import classNames from 'clsx';

// @ts-expect-error less import
import styles from './style.module.less';

/**
 * @typedef {import('./decorator-types.d.ts').DecoratorComponent} DecoratorComponent
 */

/**
 * @type {DecoratorComponent}
 */
export const Decorator = ({ children, decoration, className, decorationClassName, showDecoration = false }) => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles['child-container'], className)}>{children}</div>
      <div className={classNames(styles['decoration-container'], decorationClassName)}>{showDecoration ? decoration : null}</div>
    </div>
  );
};
